import { CreateGroupConfirmFormSchema } from 'commons/auditionForm';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';

// 多言語対応のためスキーマをフック化
export const useGroupConfirmFormSchema = () => {
  const { t } = useTranslationWithLang('auditionForm');

  const schema = CreateGroupConfirmFormSchema({
    GroupSizeTooSmallMessage: t('Validate_GroupSizeTooSmall'),
  });
  return schema;
};
